import { createSlice } from '@reduxjs/toolkit';
import { addLocation, fetchLocations, fetchLocationDetails, toggleFoodMenu, editLocation, deleteLocationByLocationId, fetchUnassignedLocations, fetchLocationById } from './locationThunk';
import { API_STATUS_TYPE } from '../../../utils/contants';

const INITIAL_STATE = {
  locations: [],
  currentLocation: null,
  foodMenu: [],
  unassignedLocations: [],
  status: API_STATUS_TYPE.IDLE,
  isLoading: false,
  error: null
};

const locationSlice = createSlice({
  name: 'location',
  initialState: INITIAL_STATE,
  reducers: {
    clearCurrentLocation: (state) => {
      state.currentLocation = null;
      state.foodMenu = [];
      state.status = API_STATUS_TYPE.IDLE;
    },
    // userManagementSlice.js or menuSlice.js
    updateItemStatusLocally: (state, action) => {
      const { itemId, isAvailable } = action.payload;
      // Find the category and then the item to update it directly in the store
      state.foodMenu.forEach((category) => {
        const item = category.foodItems.find((i) => i.id === itemId);
        if (item) {
          item.isAvailable = isAvailable;
        }
      });
    }
  },
  extraReducers: (builder) => {
    builder
      /* 1. SPECIFIC CASES ALWAYS GO FIRST */

      /// Adding new Location
      .addCase(addLocation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        if (action.payload?.data) {
          state.locations.unshift(action.payload.data);
        }
      })

      /// Fetching the Location 
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.locations = action.payload?.data || [];
      })

      .addCase(fetchLocationById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.currentLocation = action.payload.data
      })

      /// Fetching Location Details by id
      .addCase(fetchLocationDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.currentLocation = action.payload.details?.data || action.payload.details;
        const items = action.payload.menu?.data || [];

        // /// Manage Translation for the Food Items
        // const handleTranslation = (items) => {
        //     return items.map((item) => ({
        //         ...item,
        //         translationsMap: Array.isArray(item.translations)
        //           ? item.translations.reduce((acc, t) => {
        //               if (t && t.languageCode) {
        //                 acc[t.languageCode] = {
        //                   name: t.name ?? '',
        //                   description: t.description ?? ''
        //                 };
        //               }
        //               return acc;
        //             }, {})
        //           : {}
        //       }));
        // }

        // /// Handle translation for food category
        // const processedFoodCategory = items.map((item) => ({
        //   ...item,
        //   translationsMap: Array.isArray(item.translations)
        //     ? item.translations.reduce((acc, t) => {
        //         if (t && t.languageCode) {
        //           acc[t.languageCode] = {
        //             name: t.name ?? '',
        //             description: t.description ?? ''
        //           };
        //         }
        //         return acc;
        //       }, {})
        //     : {},
        //     foodItems:handleTranslation(item.foodItems)
        // }));

        // console.log(processedFoodCategory);
        
        // Set the categories array for list rendering
        state.foodMenu = items;
      })

      /// Managing the visibility of Food Items for each location
      .addCase(toggleFoodMenu.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

      /// Edit Location with the prefield data
      .addCase(editLocation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

      /// Delete the location using the location id
      .addCase(deleteLocationByLocationId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
      })

      /// Fetch all unassigned locations
      .addCase(fetchUnassignedLocations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = API_STATUS_TYPE.SUCCESSED;
        state.unassignedLocations = action.payload.data
      })

      /* 2. MATCHERS ALWAYS GO AFTER CASES */
      // Pending Matcher
      .addMatcher(
        (action) => action.type.startsWith('location/') && action.type.endsWith('/pending'),
        (state) => {
          state.isLoading = true;
          state.status = API_STATUS_TYPE.PENDING;
          state.error = null;
        }
      )

      // Rejected Matcher
      .addMatcher(
        (action) => action.type.startsWith('location/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.isLoading = false;
          state.status = API_STATUS_TYPE.FAILED;
          state.error = action?.payload || 'An unexpected error occurred';
        }
      );
  }
});

export const { clearCurrentLocation, updateItemStatusLocally } = locationSlice.actions;
export default locationSlice.reducer;
